import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { TextField } from "@material-ui/core";
import { useDebounceEffect } from "../../../utils/hooks/useDebounceEffect";

const propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  typeInput: PropTypes.string,
  handleOutput: PropTypes.func.isRequired,
  submitOnChange: PropTypes.bool,
  minChar: PropTypes.number,
  value: PropTypes.string,
};

const defaultProps = {
  placeholder: "",
  typeInput: "text",
  submitOnChange: false,
  minChar: 1,
  value: "",
};

const FilterInput = ({
  name,
  placeholder,
  typeInput,
  handleOutput,
  submitOnChange,
  minChar,
  value: initialValue,
}) => {
  const [error, setError] = useState(false);
  const [term, setTerm] = useState(initialValue || "");

  useEffect(() => {
    setTerm(initialValue || "");
  }, [initialValue]);

  useDebounceEffect(
    () => {
      if (submitOnChange) {
        if (term.length === 0 || term.length >= minChar) {
          handleOutput({ type: undefined, term });
        }
      }
    },
    500,
    [term]
  );

  const handleChange = (e, setFieldValue) => {
    const newValue = e.target.value;
    setTerm(newValue);

    if (minChar && newValue.length > 0 && newValue.length < minChar) {
      setError(true);
    } else {
      setError(false);
    }
    setFieldValue(name, newValue);

    if (newValue.length === 0 && submitOnChange) {
      handleOutput({ type: undefined, term: "" });
    }
  };

  const handleKeyDown = (e, fieldValue) => {
    if (typeInput === "number" && (e.key === "e" || e.key === "E")) {
      e.preventDefault();
    }

    if (e.key === "Enter" && !error && term.length >= minChar) {
      handleOutput({ type: undefined, term: fieldValue || term });
    }
  };

  return (
    <Field name={name}>
      {({ field, form }) => {
        const fieldValue = field.value || "";

        return (
          <TextField
            name={name}
            label={placeholder}
            value={term}
            onChange={(e) => handleChange(e, form.setFieldValue)}
            onKeyDown={(e) => handleKeyDown(e, fieldValue)}
            type={typeInput}
            variant="outlined"
            fullWidth
            error={error}
            helperText={error ? `Min. ${minChar} caracteres` : ""}
            InputProps={{
              type: typeInput,
            }}
          />
        );
      }}
    </Field>
  );
};

FilterInput.propTypes = propTypes;
FilterInput.defaultProps = defaultProps;

export default FilterInput;
